import React, {Component} from 'react'
import {Button, Modal, Pagination} from 'antd'
import PropTypes from 'prop-types'
import ItemsTable from './table-jobs/ItemsTable'
import {printedFileSessionJobs} from "../../../../services/api/3dApi"

class JobItemsModal extends Component {
    state = {
        loading: false,
        error: '',
        listJobs: [],
        page: 1,
        pages: 1,
        totals: 0,
        limit: 20,
    }

    componentDidMount() {
        this._fetchListingJobs()
    }

    _fetchListingJobs = async () => {
        const {limit, page} = this.state
        const {sessionId} = this.props

        try {
            this.setState({
                loading: true,
                error: '',
            })

            const {data: response} = await printedFileSessionJobs(`session_id=${sessionId}&limit=${limit}&page=${page}`)

            const {success, data, error} = response

            if (!success) {
                return this.setState({
                    error: error,
                    loading: false
                })
            }

            const {jobs, totals} = data

            this.setState({
                loading: false,
                totals,
                listJobs: jobs
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false,
            })
        }
    }

    _handlePageChange = (page) => {
        this.setState({
            page: page
        }, () => {
            this._fetchListingJobs()
        })
    }

    _handleShowSizeChange = (current, size) => {
        this.setState({
            limit: size,
            page: 1
        }, () => {
            this._fetchListingJobs()
        })
    }

    render() {
        const {visible, toggleModal} = this.props
        const {listJobs, loading, error, page, totals, limit} = this.state

        return (
            <Modal
                title="Danh sách items"
                width={900}
                visible={visible}
                onCancel={toggleModal}
                footer={[
                    <div key="footer" className="Footer d-flex justify-content-end align-items-center">
                        <Button type="primary" onClick={toggleModal}>
                            Đóng
                        </Button>
                    </div>,
                ]}
            >
                {error && <div className="text-danger mb-3">{error}</div>}
                <ItemsTable listJobs={listJobs} loading={loading}/>
                <div className="d-flex justify-content-end">
                    <Pagination
                        current={page}
                        total={totals}
                        pageSize={limit}
                        onChange={this._handlePageChange}
                        className='mb-3' showSizeChanger
                        pageSizeOptions={['20', '50', '100', '200']}
                        onShowSizeChange={this._handleShowSizeChange}
                    />
                </div>
            </Modal>
        )
    }
}

JobItemsModal.propTypes = {
    visible: PropTypes.bool.isRequired,
    sessionId: PropTypes.string.isRequired,
    toggleModal: PropTypes.func.isRequired
}

export default JobItemsModal
